import { View } from "@/components/ui";
import { Divider } from "@/components/shared/divider";
import { useBookingOrder } from "@/components/hooks/use-booking-order";
import { formatPrice } from "@/lib/helpers/number";
import { LineItemList } from "@/components/shared/line-item/line-item-list";
import { ListItem } from "@/components/shared/visits/visit-detail";
import { Typography } from "@/components/shared/typography";
import { PackageServiceTypeEnum } from "@/__generated__/graphql";

export const OrderDetails = ({
  showTotal,
  showTotalDivider,
}: {
  showTotal?: boolean;
  showTotalDivider?: boolean;
}) => {
  const {
    lineItems,
    totalBeforeDiscount,
    tax,
    grandTotal,
    totalDiscount,
    promo,
    percentDiscount,
    serviceDuration,
  } = useBookingOrder();

  const isDeepCleaningDetail =
    lineItems?.length > 0 &&
    lineItems[0]?.serviceType === PackageServiceTypeEnum.DeepCleaning;

  return (
    <>
      <View className="max-h-[20vh] overflow-y-auto">
        <LineItemList lineItems={lineItems} withUnit={!isDeepCleaningDetail} />
      </View>
      <Divider className="my-3" />
      <View className="flex flex-col gap-1">
        <ListItem label="Service Duration / Visit" value={serviceDuration} />
        <ListItem label="Total Cost" value={formatPrice(totalBeforeDiscount)} />
        {!!totalDiscount && (
          <ListItem
            label={`Discount, ${percentDiscount}%`}
            value={formatPrice(-totalDiscount)}
          />
        )}
        {!!promo && (
          <ListItem
            label="Promo"
            value={`${formatPrice(0 - promo.computedDiscount)}`}
          />
        )}
        <ListItem label="GST (9%)" value={formatPrice(tax)} />
      </View>
      {showTotalDivider && <Divider className="mt-2" />}
      {showTotal && (
        <View className="flex flex-row items-center justify-between py-3">
          <Typography variant="caption-md">
            {`Total (${lineItems.length || 0} ${lineItems?.length > 1 ? "Items" : "Item"})`}
          </Typography>
          <View className="flex flex-row items-center gap-1">
            <Typography variant="caption-md" color="brand-primary">
              {formatPrice(grandTotal)}
            </Typography>
            <Typography variant="caption-md" color="secondary-text">
              w/GST
            </Typography>
          </View>
        </View>
      )}
    </>
  );
};
